import {KpiInfo, ValidationError, Validator} from "../../../../../types/types";
import {StringUtils} from "../../../../../utils/stringUtils";

export class ScriptConfigurationValidator implements Validator<KpiInfo> {

    validate(kpiInfo: KpiInfo): ValidationError[] {
        const validationErrors = [];
        const queriesLength = kpiInfo.configuration.queries.length;
        if (queriesLength > 1 && StringUtils.isEmpty(kpiInfo.statusEvaluator)) {
            validationErrors.push(new ValidationError("script", `You have created ${queriesLength} queries. Please provide the script for finding the KPI from those queries`));
        }
        return validationErrors;
    }


}

